import { scrollWindowTo } from 'widgets/toolbox/scroll';

/**
 * @param AccessibilityFocusMixin Base widget for extending
 * @returns CoreAccessibilityFocusMixin class
 */
function CoreAccessibilityFocusMixinClassCreator(AccessibilityFocusMixin: import('widgets/global/AccessibilityFocusMixin').TAccessibilityFocusMixin) {
    /**
     * @category widgets
     * @subcategory global
     * @class CoreAccessibilityFocusMixin
     * @augments AccessibilityFocusMixin
     */
    class CoreAccessibilityFocusMixin extends AccessibilityFocusMixin {
        /**
         * @description Method to focus on first focusable input, accepts refName as param to search input in
         * @param containerRefName container ref name to get focusable elements in, or nothing to get from `self`
         * @param needScrollIntoView scroll into view active element after focus
         */
        focusFirstInput(containerRefName = 'self', needScrollIntoView = false): void {
            const focusableInputElements = this.getFocusableInputElements(containerRefName);

            if (focusableInputElements.length) {
                (focusableInputElements[0] as HTMLElement).focus();

                if (needScrollIntoView) {
                    scrollWindowTo(focusableInputElements[0] as HTMLElement, true, false);
                }
            }
        }
    }

    return CoreAccessibilityFocusMixin;
}

export type TCoreAccessibilityFocusMixin = ReturnType<typeof CoreAccessibilityFocusMixinClassCreator>;

export type TCoreAccessibilityFocusMixinInstance = InstanceType<TCoreAccessibilityFocusMixin>;

export default CoreAccessibilityFocusMixinClassCreator;
